<div class="search-bar">
  <span class="p-input-icon-right">
    <i class="pi pi-times cross-icon" (click)="resetSearch()" *ngIf="searchString?.length > 0"></i>
    <input pInputText BlockLateralArrowNavigation class="text-input" autocomplete="off" placeholder="Search Projects" type="text"
           [(ngModel)]="searchString" name="name" (input)="topSearchBar()">
  </span>
</div>

<div class="reports-middle">
  <div class="report header-report">
    <div class="number-block">
      <div class="number-name">Number</div>
    </div>
    <div class="project-block">
      <div class="project-name">Name</div>
    </div>
    <div class="project-block">
      <div class="project-name">Overall Complexity</div>
    </div>
  </div>

  <div class="reports-block loading-reports-block" *ngIf="reportsLoading">
    <lib-progress-spinner></lib-progress-spinner>
  </div>

  <div class="reports-block" *ngIf="!reportsLoading">
    <div class="report">
      <p-accordion [activeIndex]="openedReports" (onOpen)="openProjReport($event)" (onClose)="closeProjReport($event)"
                   [multiple]="true">
        <p-accordionTab class="report-tab"
                        *ngFor="let complexReport of complexReports; index as i">
          <p-header>
            <div class="number-block">
              <div class="report-name">{{complexReport.project.number}}</div>
            </div>
            <div class="project-block">
              <div class="project-name">{{complexReport.project?.name}}</div>
            </div>
            <div class="project-block">
              <div class="project-name">Complexity: {{complexReport.overallComplexity | number: '1.2-2'}}</div>
            </div>
          </p-header>

          <div class="report-cabinets-body-block">
            <ng-container *ngIf="complexReport.cabinets?.length > 0">

              <app-report-cabinets-table [cabReports]="complexReport.cabinets"></app-report-cabinets-table>

              <div class="report-cabinets-bottom-block">
                <div class="report-cabinets-total-price">
                  Overall Complexity (M/H): {{complexReport.overallComplexity | number: '1.2-2'}}
                </div>
              </div>
              <div class="buttons-block">
                <div class="space-block"></div>

                <button mat-button (click)="createReport(complexReport, $event)"
                        class="report-button create-report">
                  <span>Report</span>
                </button>
              </div>
            </ng-container>
            <div *ngIf="!complexReport.cabinets || !complexReport.cabinets?.length"> No Cabinets</div>
          </div>
        </p-accordionTab>
      </p-accordion>

    </div>
  </div>

  <div class="paginator-block">
    <p-paginator #orderPaginator [rows]="repElemsCount" [totalRecords]="totalRecords"
                 (onPageChange)="getReportsLazy($event.page, $event.rows)">
    </p-paginator>
  </div>
</div>
